import { ctx } from '../canvas.js';
import { state } from '../state.js';
import { AIM_DRAG, AIM_DOT_STEP, AIM_FADE, AIM_LIFT, AIM_STEPS, GRAVITY } from '../config.js';
import { mods } from '../modes.js';
import { angleSlider, powerSlider } from '../dom.js';
import { SPECIALS } from '../progress.js';
import { facingOf, gorillaFistPos } from './gorilla.js';

// Dotted trajectory preview for the human player. Hidden while a banana is in
// the air, after the match ends, and during the CPU's turn.
export function drawAim() {
  // Nothing on the front-end is aiming at anything.
  if (state.screen !== 'game') return;
  // The guide belongs to whoever is throwing, so it goes away for the machine and for a
  // rival on the other end of a wire alike — the two are the same thing from here.
  const otherThrows = state.online ? state.turn !== state.seat : (state.cpuOn && state.turn === 1);
  if (state.projectile || state.matchOver || otherThrows) return;

  const p = state.players[state.turn];
  if (!p || !p.alive) return;

  const dir = facingOf(state.turn);
  const start = gorillaFistPos(p, state.turn);
  const a = Number(angleSlider.value) * Math.PI / 180;

  // The Rastro special simply lets the preview reach further, which is what
  // makes it worth spending. Read off the side doing the aiming: the CPU has a
  // selection of its own now, and borrowing the human's would draw a lie.
  const mine = state.special[state.turn];
  const scale = (mine && SPECIALS[mine].aimScale) || 1;
  const steps = Math.round(AIM_STEPS * scale);

  // The preview is deliberately a rough guide — it never accounts for the wind,
  // which is the whole point of the weather mode. It does follow the mode's
  // gravity, though, because a lunar arc drawn like an earth one is not a rough
  // guide, it is a lie.
  const lift = AIM_LIFT * (mods().gravity / GRAVITY);

  // And how hard it is thrown, which is the other half of the arrow. The real
  // launch is `power * SPEED_SCALE`, so a preview flying at a flat unit speed was a
  // guide to the angle and nothing else: measured, 15% and 100% painted the same 16
  // dots over the same 155px, and the one slider whose whole job is to make the shot
  // go further changed nothing the player could see. Scaling the launch speed by the
  // power makes the guide's reach AND its droop follow the slider — a weak throw
  // arcs short and steep, a full one flies flat and far — and full power reproduces
  // exactly the arc this used to draw.
  const power = Number(powerSlider.value) / 100;

  let vx = Math.cos(a) * dir * power;
  let vy = -Math.sin(a) * power;
  let px = start.x;
  let py = start.y;

  ctx.save();
  ctx.fillStyle = '#ffe07a';
  for (let i = 0; i < steps; i++) {
    vx *= AIM_DRAG;
    vy += lift;
    px += vx * AIM_DOT_STEP;
    py += vy * AIM_DOT_STEP;
    ctx.globalAlpha = 0.65 * (1 - i / (AIM_FADE * scale));
    ctx.beginPath();
    ctx.ellipse(px, py, 3, 2, 0, 0, Math.PI * 2);
    ctx.fill();
  }
  ctx.restore();
}
